import {useAppSelector} from '@src/Store/hooks';

const useHeaderOptions = () => {
  return useAppSelector(state => state.app.headerOptions);
};

export default useHeaderOptions;
